import { type TranslationTree } from '@/i18n/types';

export const messages = {
  error: 'Não foi possível enviar o arquivo, tente novamente',
} satisfies TranslationTree;
